module.exports = "<div [ngClass]=\"setPosition()\" aria-label=\"badge\" role=\"img\">\n\t<div class=\"igx-badge__circle\" [ngClass]=\"setClasses()\" [attr.aria-roledescription]=\"roleDescription\">\n\t\t<span *ngIf=\"!iconBdg\" class=\"igx-badge__circle-value\">{{value}}</span>\n\t\t<igx-icon *ngIf=\"iconBdg\" fontSet=\"material\" [name]=\"iconBdg\"></igx-icon>\n\t\t<!-- <i *ngIf=\"iconBdg\" class=\"material-icons igx-badge__circle-value\" >{{iconBdg}}</i> -->\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/badge/badge.component.html
// module id = 81
// module chunks = 0 1